import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";

export default function RequireAuth({ children }) {
  let { isSigned, isCheckingSession } = useAuth();
  let location = useLocation();

  if (isCheckingSession) {
    return <div role="status">Validando sessão...</div>;
  }

  if (!isSigned) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
